module.exports = __webpack_public_path__ + "static/media/topRounded.eec14d54.png";